import { render, staticRenderFns } from "./sendSMSCustomer.vue?vue&type=template&id=19924444&scoped=true"
import script from "./sendSMSCustomer.vue?vue&type=script&lang=js"
export * from "./sendSMSCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19924444",
  null
  
)

export default component.exports